export default __webpack_public_path__ + "static/media/salesforce-dark.ed3639f6.svg";